import moment from "moment"
import React, { useState } from "react"
import { Loader } from "react-feather"
import { CardBody } from "reactstrap"
import styled from "styled-components"
import ModalPopup from "../../../components/ModalPopup"
import PageBody from "../../../components/PageBody"
import RowEmpty from "../../../components/RowEmpty"

const OrderAddHistory = (props:any) => {
    const {history} = props
    const [modalIsOpen, setIsOpen] = useState(false);
    
    

    return(
        <>
        <PageBody>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div className="nutri-title mb-3">Lịch sử thao tác</div>
                <b className="text-success cursor-pointer" onClick={() => setIsOpen(!modalIsOpen)}>Xem lịch sử</b>
            </div>
        </PageBody>
        <ModalPopup
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
        >
            <RenderActionModalHistory {...props} history={history} closeModal={() => setIsOpen(false)} />
        </ModalPopup>
        </>
    )
}

const HistoryItem = ({item, index, history}:any)=>{
    if(item?.status === -1){
        return(
            <tr>
                <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td>{item?.created_uid?.name}</td>
                <td>Hủy phiếu</td>
            </tr>
        )
    }else if(item?.status === 3){
        return(
            <tr>
                <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td>{item?.created_uid?.name}</td>
                <td>Hoàn thành</td>
            </tr>
        )
    }else if(item?.status === 2){
        return(
            <tr>
                <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td>{item?.created_uid?.name}</td>
                <td>Xuất kho</td>
            </tr>
        )
    }else if(item?.status === 1){
        return(
            <tr>
                <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td>{item?.created_uid?.name}</td>
                <td>Xác nhận</td>
            </tr>
        )
    }else if(history[index-1]){
        return(
            <tr>
                <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td>{item?.created_uid?.name}</td>
                <td>Cập nhật</td>
            </tr>
        )
    }else if(item?.status === 0){
        return(
            <tr>
                <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td>{item?.created_uid?.name || item?.created_uid?.name}</td>
                <td>Tạo mới</td>
            </tr>
        )
    }
    return(
        <tr>
            <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
            <td>{item?.created_uid?.name}</td>
            <td>Tạo mới</td>
        </tr>
    )
}

const RenderActionModalHistory = (props: any) => {
    const [loading, setLoading] = useState(false);
    const [payment, setPayment] = useState(props?.payment);
    const { closeModal, onlyView, history } = props
    return (
        <CardBody className='p-0' style={{width:600}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">Lịch sử thanh toán</h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-0">
                <PageContent className={onlyView ? 'only-view' : ''}>
                    <div className="table-responsive" style={{overflow: 'unset'}}>
                        <table className="mb-0 table-custom no-bg table table-input" >
                            <thead>
                                <tr>
                                    <th style={{ width: '30%' }}>Thời gian</th>
                                    <th style={{ width: '30%' }}>Người thực hiện</th>
                                    <th style={{ width: '30%' }}>Hành động</th>
                                </tr>
                            </thead>
                            {history?.length === 0 && <RowEmpty column={4} title="Lịch sử thanh toán trống!" />}
                            {history?.length > 0 && <tbody>
                            {
                                history?.map((item:any, index:number) => (
                                    <HistoryItem 
                                        item={item}
                                        index={index}
                                        history={history}
                                    />
                                ))
                            }
                            </tbody>}
                        </table>
                    </div>
                </PageContent>
            </div>
            {loading && <Loader />}
        </CardBody>
    )
}
const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`
export default OrderAddHistory